export default __webpack_public_path__ + "static/media/roboto-v27-latin-100.25385d9f.woff2";